/**
 * 原生Dom方法，用于替换jQuery方法
 * wiki: https://github.com/nefe/You-Dont-Need-jQuery
 */
const KDom = {}

// Native - IE10+
KDom.closest = function (el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector

  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el
    } else {
      el = el.parentElement
    }
  }
  return null
}

export default KDom
